import flatpickr from "flatpickr";
let validate = require("validate.js");
let _ = require("lodash");
let moment = require("moment");

(function ($) {
  const form = $(".start-service-form");
  const currentDate = new Date();

  // Date Time Validation Format
  validate.extend(validate.validators.datetime, {
    // The value is guaranteed not to be null or undefined but otherwise it
    // could be anything.
    parse: function(value, options) {
      return +moment.utc(value);
    },
    // Input is a unix timestamp
    format: function(value, options) {
      var format = options.dateOnly ? "MM-DD-YYYY" : "MM-DD-YYYY hh:mm:ss";
      return moment.utc(value).format(format);
    }
  });

  // Default error message
  validate.validators.presence.options = {message: "^This field is required."};

  flatpickr(".first-day", {
    disable: [
      function(date) {
      return date.getDay() === 0 || date.getDay() === 6;
      }
    ],

    minDate: currentDate.setDate(currentDate.getDate() + 1),

    locale: {
      firstDayOfWeek: 1 // start week on monday
    }
  });

  $(function () {

    let $years = $('#years'),
      $months = $('#months'),
      $days = $('#days');

    var i;

    for (i = new Date().getFullYear(); i > 1900; i--) {
      $years.append($('<option />').val(i).html(i));
    }

    for (i = 1; i < 13; i++) {
      let label = "Jan";
      switch (i) {
        case 1:
          label = "Jan";
          break;
        case 2:
          label = "Feb";
          break;
        case 3:
          label = "Mar";
          break;
        case 4:
          label = "Apr";
          break;
        case 5:
          label = "May";
          break;
        case 6:
          label = "Jun";
          break;
        case 7:
          label = "Jul";
          break;
        case 8:
          label = "Aug";
          break;
        case 9:
          label = "Sep";
          break;
        case 10:
          label = "Oct";
          break;
        case 11:
          label = "Nov";
          break;
        case 12:
          label = "Dec";
          break;
        default:
          label = "Jan";
          break;
      }
      $months.append($('<option />').val(i).html(label));
    }
    updateNumberOfDays();

    $('#years, #months').change(function () {

      updateNumberOfDays();

    });

    function updateNumberOfDays() {
      var selected = $days.val();
      $days.html('');
      var month = $months.val();
      var year = $('#years').val();
      var days = daysInMonth(month, year);
      var i;

      for (i = 1; i < days + 1; i++) {
        $days.append($('<option />').val(i).html(i));
      }

      if (selected) {
        $days.val(selected);
      } else {
        $days.val(1);
      }

    }

    function daysInMonth(month, year) {
      return new Date(year, month, 0).getDate();
    }

  });


  function localstorage() {
    let mod = 'mod';
    try {
      localStorage.setItem(mod, mod);
      localStorage.removeItem(mod);
      return true;
    } catch (e) {
      return false;
    }
  }


  // The Form
  let startResidentialServiceForm = function (form, opts) {
    let _this = form;
    let isCustomer = null;
    let storageKey = "prideDisposalStartResidentialServiceForm";
    let formState = {};
    let $customerStatusSelect = $('input[name="previousServiceInName"]');
    let $billingAddressDifferent = $('input[name="billingDifferentThanServiceAddress"]');
    let $dobFields = $(".date-of-birth select");
    let $dobField = $('input[name="dateOfBirth"]');
    let $submit = $('[name="form_page_submit"]');
    let $inputs = _this.find("input, select, textarea");
    let billingAddressFields = _this.find(".billing-address");

    // validation variables
    let _phoneFormat = /^\(\d{3}\) \d{3}-\d{4}$/;
    let _zipFormat = /\d{5}(-\d{4})?/;

    // VALIDATION CONSTRAINTS
    let _constraints = {
      businessName: {
        presence: true
      },
      email: {
        presence: true,
        email: true
      },
      currentPhoneNumber: {
        presence: true,
        format: {
          pattern: _phoneFormat,
          flags: "i",
          message: "Must be a valid phone number."
        }
      },
      federalTaxIdNumber: {
        presence: true,
        numericality: true
      },
      street: {
        presence: true
      },
      city: {
        presence: true
      },
      state: {
        presence: true
      },
      zipCode: {
        presence: true,
        format: _zipFormat
      },
      firstDayCollectionIsNeeded: {
        presence: true
      },
      trashCartSize: {
        presence: true
      }
    };

    let _init = function () {
      $customerStatusSelect.change(_onCustomerStatusChange);
      $billingAddressDifferent.change(_onBillingAddressDifferentChange);
      $dobFields.change(_onDobChange);
      $inputs.change(_onFormValueUpdate);
      $submit.click(_onSubmit);

      // Phone number mask while typing in phone fields
      _.each(document.querySelectorAll('[name*="phone"], [name*="Phone"]'), function(input) {
        input.addEventListener('input', function (e) {
          var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
          e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
        });
      });
    };

    let _onLoad = function () {
      if (localstorage() && localStorage.getItem(storageKey) !== 'null') {
        let formValues = formState = JSON.parse(localStorage.getItem(storageKey)) || {};

        for (let val in formValues) {
          let input = _this.find('*[name="' + val + '"]');
          if (input.length && input.attr('type') !== "hidden") {
            if (input.attr('type') === "radio" || input.attr('type') === "checkbox" || input[0].tagName === "SELECT") {
              input.val([formValues[val]]);
            } else if (input.attr('type') === "file") {

            } else {
              input.val(formValues[val]);
            }
          }
        }
      }

      _onCustomerStatusChange();
      _onBillingAddressDifferentChange();
    };

    let _onFormValueUpdate = function () {
      // Check for errors as input is updated...
      let errors = validate(_this[0], _constraints) || {};
      _showErrorsForInput(this, errors[this.name]);

      formState[$(this).attr("name")] = $(this).val();
      _updateLocalStorage();
    };

    let _updateLocalStorage = function(fromFields) {
      if(fromFields) {
        $inputs.each(function(i, el){
          let input = $(el);
          if (input.attr('type') === "checkbox" || input.attr('type') === "radio") {
            formState[el.name] = $('[name="'+el.name+'"]').filter(':checked').val();
          } else {
            formState[el.name] = $(el).val();
          }
        });
      }
      localStorage.setItem(storageKey, JSON.stringify(formState));
    };

    let _onCustomerStatusChange = function () {
      isCustomer = $(this).val();

      let $customerFields = _this.find(".customer");

      if (isCustomer == "Yes") {
        $customerFields.show();
      } else {
        $customerFields.hide();
      }
    };

    let _onBillingAddressDifferentChange = function () {
      let billingAddressDifferent = $billingAddressDifferent.filter(':checked').val();

      if (billingAddressDifferent == "Yes") {
        _.set(_constraints, 'billingStreet', {presence: true});
        _.set(_constraints, 'billingCity', {presence: true});
        _.set(_constraints, 'billingState', {presence: true});
        _.set(_constraints, 'billingZipCode', {presence: true, format: _zipFormat});
        billingAddressFields.show();
      } else {
        _.unset(_constraints, 'billingStreet');
        _.unset(_constraints, 'billingCity');
        _.unset(_constraints, 'billingState');
        _.unset(_constraints, 'billingZipCode');
        billingAddressFields.hide();
      }
    };

    let _onDobChange = function () {
      let dob = $('select[name="months"]').val() + '-' + $('select[name="days"]').val() + '-' + $('select[name="years"]').val();

      $dobField.val(dob);
    };

    let _onSubmit = function (e) {

      // Stop form from submitting automatically
      e.preventDefault();

      // Other validation
      // console.log(validate.collectFormValues(_this[0]));
      let errors = validate(_this[0], _constraints);

      // sync local storage with input values
      _updateLocalStorage(true);

      // show errors
      _showErrors(_this[0], errors);


      if (!errors) {

        // SUCCESS
        // Remove cached data from local storage on successful submit
        localStorage.removeItem(storageKey);

        // Submit the form
        _this.submit();


      } else {

        // ERRORS
        _.delay(() => {
          console.log('running disabled on',$submit);
          $submit[0].disabled = false;
        }, 500);

        // Print generic message and scroll to top
        let $alert = $('#alert');
        if (!$alert.length) {
          _this.prepend('<div id="alert" class="alert alert-danger">There was an error submitting this form.</div>');
        }
        $('#alert')[0].scrollIntoView();

      }

    };

    // loop through fields, look for errors in errors object
    let _showErrors = function(form, errors) {

      _.each(form.querySelectorAll("[type=file], [type=text], textarea, select, [type=email], [type=radio], [type=checkbox]"), function(input) {
        console.log(input);
        _showErrorsForInput(input, errors && errors[input.name]);
      });

    };

    // display errors if they are present for this input
    let _showErrorsForInput = function(input, errors) {

      let formGroup = _closestParent(input.parentNode, "form-group");

      // remove errors
      if(formGroup) {
        _resetFormGroup(formGroup);

        if (errors) {
          formGroup.classList.add("has-error");
          _addErrors(formGroup, errors);
        } else {
          formGroup.classList.add("has-success");
        }

      }

    };

    // create errors ul and error li items
    let _addErrors = function(formGroup, errors) {
      let list = document.createElement("ul");
      list.classList.add("errors");
      list.classList.add("error-block");
      _.each(errors, function(error){
        let listItem = document.createElement("li");
        error = _.replace(error, '[]', '');
        error = _.replace(error, /\d/, '');
        listItem.innerText = error;
        list.appendChild(listItem);
      });
      formGroup.appendChild(list);
    };

    // remove errors
    let _resetFormGroup = function(formGroup) {
      console.log(formGroup);
      formGroup.classList.remove("has-error");
      formGroup.classList.remove("has-success");
      _.each(formGroup.querySelectorAll(".errors"), function(el) {
        el.parentNode.removeChild(el);
      });
    };

    // Recursively finds the closest parent that has the specified class
    let _closestParent = function(child, className) {
      if (!child || child == document) {
        return null;
      }
      if (child.classList.contains(className)) {
        return child;
      } else {
        return _closestParent(child.parentNode, className);
      }
    };

    _onLoad();
    _init();
  };

  startResidentialServiceForm(form);

})(jQuery);



// WEBPACK FOOTER //
// ./resources/js/startBusinessServiceForm.js